import { DriverDetails } from '@acorn-portal/shared/src/services/api';

interface ISortedDrivers {
	policyHolder: DriverDetails;
	additionalDrivers: DriverDetails[];
}

const SortDrivers = (drivers: DriverDetails[]): ISortedDrivers => {
	let policyHolder: DriverDetails | undefined;
	const additionalDrivers = drivers.filter((driver) => {
		if (driver.isPolicyholder) {
			policyHolder = driver;
		}
		return !driver.isPolicyholder;
	});

	return {
		policyHolder: policyHolder as DriverDetails,
		additionalDrivers,
	};
};

export default SortDrivers;
